import React from "react";
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom"
import classes from "./styles.module.css"; 
import {Image} from "./style";
import { useParams } from "react-router-dom";
import APIConfig from "../../../../api/APIConfig";
import {
    Box,
    Center,
    Heading,
    Text,
    Button,
    VStack,
    StackDivider,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
} from '@chakra-ui/react';

function ProfilMitra() {
    const [namaResmi, setNamaResmi] = useState('');
    const [namaBrand, setNamaBrand] = useState('');
    const [website, setWebsite] = useState('');
    const [status, setStatus] = useState('');
    const [tahunBerdiri, setTahunBerdiri] = useState('');
    const [kategori, setKategori] = useState('');
    const [sektorBisnis, setSektorBisnis] = useState('');
    const [sizeMitra, setSizeMitra] = useState('');
    const [lokasiPusat, setLokasiPusat] = useState('');
    const [alamat, setAlamat] = useState('');
    const [npwp, setNpwp] = useState('');
    const [nib, setNib] = useState('');

    const [image, setImage] = useState('');
    const [tagline, setTagline] = useState('');
    const [shortdesc, setShortdesc] = useState('');

    const [namabankmitra, setNamabankmitra] = useState('');
    const [namaAkunMitra, setNamaAkunMitra] = useState('');
    const [nomorAkunmitra, setNomorAkunmitra] = useState('');
    
    const getMitraById = async() => {
        const response = await APIConfig.get(`/v1/mitra/${id}`);
        const data = await response.data
        setNamaResmi(data.namaResmi);
        setNamaBrand(data.namaBrand);
        setWebsite(data.website);
        setStatus(data.status);
        setTahunBerdiri(data.tahunBerdiri);
        setKategori(data.kategori);
        setSektorBisnis(data.sektorBisnis);
        setSizeMitra(data.sizeMitra);
        setLokasiPusat(data.lokasiPusat);
        setAlamat(data.alamat);
        setNpwp(data.npwp);
        setNib(data.nib);

        setImage(data.image);
        setTagline(data.tagline);
        setShortdesc(data.shortdesc);

        setNamabankmitra(data.namabankmitra);
        setNamaAkunMitra(data.namaAkunMitra);
        setNomorAkunmitra(data.nomorAkunmitra);
        console.log("ada "+response)
    };

    const { id } = useParams();

    useEffect(() => {
        getMitraById();
        
    });

    return (
        <div className="container">
            <div>
            <Center py={6} marginRight={'12'}>
            <VStack align='stretch' fontFamily={'Inter'}>
                <Text
                    pt={10}
                    paddingBottom={10}
                    color={'gray.700'}
                    fontWeight={600}
                    fontSize={'3xl'}>
                    Profil
                </Text>
                <Box
                    m='10px'
                    w='4xl'
                    h="100%"
                    border='1px'
                    borderColor='gray.200'
                    justifyContent='left'
                    rounded={'2xl'}
                    p={6}
                    className={classes.box}
                    overflow={'hidden'}>
                    <Accordion allowToggle defaultIndex={[0]} allowMultiple>
                        <AccordionItem mb={'15px'} border='0px'>
                            <AccordionButton>
                                <Box flex='1' textAlign='left'>
                                    <Heading fontSize={'xl'} fontFamily={'Inter'} className={classes.h1}>
                                        Identitas
                                    </Heading>
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                            <AccordionPanel pb={4}>
                                <VStack 
                                divider={<StackDivider borderColor='gray.200' />}
                                spacing={4}
                                align='stretch'>
                                <div>
                                    <h3 className={classes.h} >Nama Resmi</h3>
                                    <p className={classes.p}>{namaResmi}</p>
                                </div>
                                <div>
                                    <h3 className={classes.h}>Nama Brand</h3>
                                    <p className={classes.p}>{namaBrand}</p> 
                                </div>
                                <div>
                                    <h3 className={classes.h}>Tahun berdiri</h3>
                                    <p className={classes.p}>{tahunBerdiri}</p> 
                                </div>
                                <div>
                                    <h3 className={classes.h}>Website</h3>
                                    <p className={classes.p}>{website}</p>
                                </div>
                                <div>
                                    <h3 className={classes.h}>Status</h3>
                                    <p className={classes.p}>{status}</p>
                                </div>
                                </VStack>
                            </AccordionPanel>
                        </AccordionItem>

                        <AccordionItem mb={'15px'} border='0px'>
                        <AccordionButton>
                                <Box flex='1' textAlign='left'>
                                    <Heading fontSize={'xl'} fontFamily={'Inter'} className={classes.h1}>
                                        Detail Mitra
                                    </Heading>
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                            <AccordionPanel pb={4}>
                                <VStack 
                                divider={<StackDivider borderColor='gray.200' />}
                                spacing={4}
                                align='stretch'>
                                <div>
                                    <h3 className={classes.h} >Kategori</h3>
                                    {kategori === 0 ? (
                                        <p className={classes.p}>Startup</p> 
                                    ) : (
                                        kategori === 1 ? (
                                        <p className={classes.p}>Global Company</p>
                                    ) : (
                                        kategori === 2 ? (
                                        <p className={classes.p}>Multilaterals Organizations</p>
                                    ) : (
                                        kategori === 3 ? (
                                        <p className={classes.p}>Non-profits Organizations</p>
                                    ) : (
                                        <p className={classes.p}>Hospitals</p>
                                    ))))}
                                </div>
                                <div>
                                    <h3 className={classes.h}>Sektor Bisnis</h3>
                                    {sektorBisnis === 0 ? (
                                        <p className={classes.p}>Technology</p> 
                                    ) : (
                                        sektorBisnis === 1 ? (
                                        <p className={classes.p}>BUMN</p>
                                    ) : (
                                        sektorBisnis === 2 ? (
                                        <p className={classes.p}>Healthcare and Hospitality</p>
                                    ) : (
                                        sektorBisnis === 3 ? (
                                        <p className={classes.p}>Multilaterals and Non-profits</p>
                                    ) : (
                                        sektorBisnis === 4 ? (
                                            <p className={classes.p}>Professional Services</p>
                                    ) : (
                                        <p className={classes.p}>Other</p>
                                    )))))}
                                </div>
                                <div>
                                    <h3 className={classes.h}>Ukuran Organisasi (Jumlah Karyawan)</h3>
                                    {sizeMitra === 0 ? (
                                        <p className={classes.p}>1-10</p> 
                                    ) : (
                                        sizeMitra === 1 ? (
                                        <p className={classes.p}>11-50</p>
                                    ) : (
                                        sizeMitra === 2 ? (
                                        <p className={classes.p}>51-100</p>
                                    ) : (
                                        sizeMitra === 3 ? (
                                        <p className={classes.p}>100-500</p>
                                    ) : (
                                        sizeMitra === 4 ? (
                                            <p className={classes.p}>501-1000</p>
                                    ) : (
                                        sizeMitra === 5 ? (
                                            <p className={classes.p}>1001-5000</p>
                                    ) : (
                                        sizeMitra === 6 ? (
                                        <p className={classes.p}>5001-10000</p>
                                    ) : (
                                        <p className={classes.p}>+10000</p>
                                    )))))))}
                                </div>
                                <div>
                                    <h3 className={classes.h}>Lokasi Pusat</h3>
                                    <p className={classes.p}>{lokasiPusat}</p>
                                </div>
                                <div>
                                    <h3 className={classes.h}>Alamat</h3>
                                    <p className={classes.p}>{alamat}</p>
                                </div>
                                <div>
                                    <h3 className={classes.h}>NPWP (Nomor Pokok Wajib Pajak)</h3>
                                    <p className={classes.p}>{npwp}</p>
                                </div>
                                <div>
                                    <h3 className={classes.h}>NIB (Nomor Induk Berusaha)</h3>
                                    <p className={classes.p}>{nib}</p>
                                </div>
                                </VStack>
                            </AccordionPanel>
                        </AccordionItem>

                        <AccordionItem mb={'15px'} border='0px'>
                        <AccordionButton>
                                <Box flex='1' textAlign='left'>
                                    <Heading fontSize={'xl'} fontFamily={'Inter'} className={classes.h1}>
                                        Detail Profil
                                    </Heading>
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                            <AccordionPanel pb={4}>
                                <VStack 
                                divider={<StackDivider borderColor='gray.200' />}
                                spacing={4}
                                align='stretch'>
                                <div>
                                    <h3 className={classes.image} >Logo</h3>
                                    <Image src={image}></Image>
                                </div>
                                <div>
                                    <h3 className={classes.h}>Tagline</h3>
                                    <p className={classes.p}>{tagline}</p> 
                                </div>
                                <div>
                                    <h3 className={classes.h}>Deskripsi Singkat</h3>
                                    <p className={classes.p}>{shortdesc}</p>
                                </div>
                                </VStack>
                            </AccordionPanel>
                        </AccordionItem>

                        <AccordionItem mb={'15px'} border='0px'>
                        <AccordionButton>
                                <Box flex='1' textAlign='left'>
                                    <Heading fontSize={'xl'} fontFamily={'Inter'} className={classes.h1}>
                                        Akun Bank
                                    </Heading>
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                            <AccordionPanel pb={4}>
                                <VStack 
                                divider={<StackDivider borderColor='gray.200' />}
                                spacing={4}
                                align='stretch'>
                                <div>
                                    <h3 className={classes.h} >Nama Bank</h3>
                                    <p className={classes.p}>{namabankmitra}</p>
                                </div>
                                <div>
                                    <h3 className={classes.h}>Nama Akun</h3>
                                    <p className={classes.p}>{namaAkunMitra}</p> 
                                </div>
                                <div>
                                    <h3 className={classes.h}>Nomor Akun</h3>
                                    <p className={classes.p}>{nomorAkunmitra}</p>
                                </div>
                                </VStack>
                            </AccordionPanel>
                        </AccordionItem>
                    </Accordion>
                    <Center pt={6}>
                        <Link to={`/mitra/profile/isi-profil/${id}`}>
                            <Button p={6} w='100%' rounded={'xl'} colorScheme='purple' variant='solid'>
                                <h3 className={classes.h}>Edit Profil</h3>
                            </Button>
                        </Link>
                    </Center>
                </Box>)
            </VStack>
        </Center>
            </div>
        </div>
    );
}

export default ProfilMitra;